var Curriculog = Curriculog || {};

Curriculog.Proposal = (function ($, _, Backbone, Form) {

    Proposal = Curriculog.CurriculogModel.extend({
        defaults: {
            id: 0,
            parentId: 0,
            approvalProcessId: 0,
            crosslisted: 0,
            crosslistingRequireReview: 0,
            status: 'unlaunched',
            type: 'course',
            waitingSig: '',
            originator: 0,
            user: 0,
            currentStepId: 0,
            proposalName: 'New Proposal',
            entities: '',
            decision: '',
            s3Operation: '',
            s3File: '',
            acalogGateway: '',
            agendaId: '',
            crosslistingEnabled: 'none',
            createAssessments: 0,
            showHelp: false
        },

        /**
         * A collection of all this forms fields
         *
         * @type {Backbone.Collection}
         */
        fields: null, // collection

        /**
         * Generates the url for the models sync events
         *
         * @returns {String}
         */
        url: function() {
            return '/proposal:' + this.id + '/ajax/makeDecision.json';
        },

        /**
         * Called after a sync event with the response data. Used to normalize the response object.
         *
         * @param   {jqxhr} response - jQuery response object
         * @param   {Object} options - Sync Options
         * @returns {Object}         - The normalized data to save in the model
         */
        parse: function(response, options) {
            // the local current step Id uses a lower case 'd'
            response.data.currentStepId = response.data.currentStepID;
            delete response.data.currentStepID;
            return response.data;
        },

        /**
         * Used to get the value of the prefix field
         *
         * @returns {String}
         */
        get_prefix:function() {
            var field = this.fields.findWhere({systemRequired: 'coursePrefix'});
            return field.getDisplayValue();
        },

        get_code: function() {
            var field = this.fields.findWhere({systemRequired: 'courseCode'});
            return field.getDisplayValue();
        },

        // get_entities: function() {
        //     var field = this.fields.findWhere({systemRequired: 'proposalEntity'});
        //     return field.getDisplayValue();
        // },


        /**
         * Initialize properties for the list
         */
        initialize: function() {
            // The following two lines are used by the proposal list
            this.level = 'user';
            this.setCrosslisted();
        },


        setPermissions: function(level) {
            if (this.has('proposalPermissions')) {
                this.level = level;
                this.set('proposalPermissions', {
                    isEligibleUser: this.isEligibleUser(),
                    canEdit: this.canEdit(),
                    canComment: this.canComment(),
                    isAgendaAdmin: this.isAgendaAdmin(),
                    canWatch: this.canWatch(),
                    canExport: this.canExport(),
                    canMessage: this.canMessage(),
                    canDelete: this.canDelete(),
                    isWatching: this.isWatching(),
                    isTask: this.isTask(),
                    isMine: this.isMine(),
                    showDecision: this.showDecision()
                });

            }
        },

        isEligibleUser: function() {
            if (this.level == 'admin') {
                return false;
            }
            return this.get('proposalPermissions').isEligibleUser;
        },

        canEdit: function() {
            if (this.level == 'admin') {
                return false;
            }
            return this.get('proposalPermissions').canEdit;
        },

        canComment: function() {
            if (this.level == 'admin') {
                return false;
            }
            return this.get('proposalPermissions').canComment;
        },

        isAgendaAdmin: function() {
            if (this.level == 'admin') {
                return false;
            }
            return this.get('proposalPermissions').isAgendaAdmin;
        },

        canWatch: function() {
            if (this.level == 'admin') {
                return false;
            }
            return this.get('proposalPermissions').canWatch;
        },

        canExport: function() {
            if (this.level == 'admin' && this.get('status') == 'completed') {
                return true;
            }
            return false;
        },

        canMessage: function() {
            if (this.level == 'admin') {
                return false;
            }
            return this.get('proposalPermissions').canMessage;
        },

        canDelete: function() {
            if (
                (this.level == 'admin' && this.get('status') != 'reviewing') ||
                (this.level == 'user' && this.get('status') == 'unlaunched')
            ) {
                return true;
            }

            return false;
        },

        isWatching: function() {
            if (this.level == 'admin') {
                return false;
            }
            return this.get('proposalPermissions').isWatching;
        },

        isTask: function() {
            if (this.level == 'admin') {
                return false;
            }
            return this.get('proposalPermissions').isTask;
        },

        isMine: function() {
            if (this.level == 'admin') {
                return false;
            }
            return this.get('proposalPermissions').isMine;
        },

        showDecision: function() {
            if (this.level == 'admin') {
                return false;
            }
            return this.get('proposalPermissions').showDecision;
        },

        setCrosslisted: function() {
            this.set('crosslisted', Boolean(this.get('crosslisted')));
        }

    });

    return Proposal;

})($, _, Backbone, Curriculog.Proposal || {});